import React from "react";
import { Link } from "react-router-dom";
import "./Service_outer_card.css";

function Service_outer_card({title,description,bgImgSrc,MainImgSrc, baseLink,id}) {
  return (
    <section className="service-card">
      <div className="service-bg-img-holder">
        <img
          className="service-bg-img"
          src={process.env.PUBLIC_URL + bgImgSrc}
          alt="service-bg-img"
        />
      </div>
      <div className="service-card-image">
        <img
          className="Service-img"
          src={process.env.PUBLIC_URL + MainImgSrc}
          alt="Service-img"
        />
      </div>
      <div className="service-card-content">
        <h2>{title}</h2>
        <p>
          {description}
        </p>
        <Link to={`${baseLink}/${id}`}>
          <div className="read-more">
            {" "}
            <span>READ MORE</span>
          </div>
        </Link>
      </div>
    </section>
  );
}

export default Service_outer_card;
